define(["exports", "@babel/runtime/helpers/esm/assertThisInitialized", "@babel/runtime/helpers/esm/inheritsLoose", "@babel/runtime/helpers/esm/defineProperty", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "react-onclickoutside", "react-intl-universal", "../../atoms", "../../utils", "../../themes"], function (_exports, _assertThisInitialized2, _inheritsLoose2, _defineProperty2, _taggedTemplateLiteralLoose2, _react, _styledComponents, _reactOnclickoutside, _reactIntlUniversal, _atoms, _utils, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _reactOnclickoutside = _interopRequireDefault(_reactOnclickoutside);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);

  var _templateObject;

  var NavigationUserStyled = (0, _styledComponents.default)(_atoms.NavList).withConfig({
    displayName: "NavigationUser__NavigationUserStyled",
    componentId: "sc-1y2hs1p-0"
  })(["background:", ";padding:0;padding-top:", ";position:relative;> li > a{color:", ";margin-bottom:8px;text-align:right;box-icon{fill:", ";}}li li{padding-bottom:0;&:nth-last-child(2){border-bottom:1px solid ", ";padding-bottom:16px;}&:last-of-type{display:none;}}", ""], function (_ref) {
    var theme = _ref.theme;
    return "linear-gradient(to right, " + theme.colors.primary + " 0%, " + theme.colors.darkOrange + " 100%)";
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.scafolding.headerHeight;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.white;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.white;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.gray;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    background: none;\n    border-bottom: 0;\n    padding-top: 0;\n\n    > * {\n      text-align: right;\n    }\n\n    li li {\n      padding-bottom: 0;\n\n      &:nth-last-child(2) {\n        border: 0;\n        padding-bottom: 0;\n      }\n\n      &:last-of-type {\n        display: block;\n      }\n    }\n  "]))));

  var NavigationUser = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2.default)(NavigationUser, _Component);

    function NavigationUser() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        opened: false
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdown", function (e) {
        e.preventDefault();

        _this.setState(function (prevState) {
          return {
            opened: !prevState.opened
          };
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function () {
        _this.setState({
          opened: false
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFirstName", function (name) {
        return name == null ? void 0 : name.split(' ')[0];
      });
      return _this;
    }

    var _proto = NavigationUser.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          acessos = _this$props.acessos,
          funcionario = _this$props.funcionario,
          globalUrl = _this$props.globalUrl,
          logoffClick = _this$props.logoffClick,
          parseMoveToParams = _this$props.parseMoveToParams;
      var opened = this.state.opened;
      return /*#__PURE__*/_react.default.createElement(NavigationUserStyled, null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
        icon: "true",
        title: this == null ? void 0 : this.getFirstName(funcionario == null ? void 0 : funcionario.nome),
        "data-title": this == null ? void 0 : this.getFirstName(funcionario == null ? void 0 : funcionario.nome),
        onClick: this.toggleDropdown,
        href: "#",
        active: "" + opened
      }, this.getFirstName(funcionario == null ? void 0 : funcionario.nome), ' ', /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "chevron-down"
      })), /*#__PURE__*/_react.default.createElement(_atoms.DropdownBox, {
        active: opened
      }, acessos.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: "user-menu-" + item
        }, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
          sublink: "true",
          as: _atoms.GlobalLink,
          to: parseMoveToParams ? (0, _utils.moveToParams)(item) : "/" + item,
          globalUrl: globalUrl,
          title: _reactIntlUniversal.default.get("NAVEGACAO_USUARIO." + (0, _utils.intlParse)(item))
        }, _reactIntlUniversal.default.get("NAVEGACAO_USUARIO." + (0, _utils.intlParse)(item))));
      }), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
        sublink: "true",
        as: _atoms.GlobalLink,
        to: parseMoveToParams ? (0, _utils.moveToParams)('finalizar-sessao') : '/finalizar-sessao',
        globalUrl: globalUrl,
        title: _reactIntlUniversal.default.get('NAVEGACAO_USUARIO.LOGOFF'),
        onClick: function onClick(e) {
          return logoffClick(e);
        }
      }, _reactIntlUniversal.default.get('NAVEGACAO_USUARIO.LOGOFF'))))));
    };

    return NavigationUser;
  }(_react.Component);

  NavigationUser.defaultProps = {
    logoffClick: function logoffClick() {}
  };

  var _default = (0, _reactOnclickoutside.default)(NavigationUser);

  _exports.default = _default;
});